<template>
	<eg-modal
		height="300px"
		width="800px"
		:show="show"
		@close="$emit('close', false)"
		><p class="center" slot="header"><b>Contato</b></p>
		<div slot="body">
			<template v-if="supplier.responsible">
				<p id="contact-responsible">
					Nome do responsável: {{ supplier.responsible || "-" }}
				</p>
				<p id="contact-email">
					E-mail do responsável: {{ supplier.email || "-" }}
				</p>
				<p id="contact-phone">
					Telefone do responsável: {{ supplier.phone || "-" }}
				</p>
			</template>
			<template v-else>
				<p id="contact-responsible">
					Fornecedor: {{ supplier.name || "-" }}
				</p>
				<p id="contact-email">E-mail: {{ supplier.email || "-" }}</p>
				<p id="contact-phone">Telefone: {{ supplier.phone || "-" }}</p>
				<p id="contact-phone">Website: {{ supplier.website || "-" }}</p>
			</template>
		</div>
	</eg-modal>
</template>

<script>
export default {
    name: 'supplierContact',
    props: {
        show: Boolean,
        supplier: {
            type: Object,
            default: () => {
                return {
                    responsible: false,
                };
            },
        },
    },
};
</script>

<style></style>
